import { Box3, Line, Mesh, Object3D } from 'three'

import type { GLTFObject } from '@/lib/cad/GLTFObject'

const addGeometryBounds = (object: Mesh | Line, target: Box3) => {
  const geometry = object.geometry

  if (!geometry.boundingBox) geometry.computeBoundingBox()
  if (!geometry.boundingBox) return

  target.union(
    new Box3().copy(geometry.boundingBox).applyMatrix4(object.matrixWorld),
  )
}

const expandStepObjectBounds = ({
  gltf,
  hiddenPartIds,
  object,
  target,
}: {
  gltf: GLTFObject
  hiddenPartIds: Set<string>
  object: Object3D
  target: Box3
}) => {
  const node = gltf.objectNodeMap.get(object)
  if (node && hiddenPartIds.has(node.uuid)) return

  if (object instanceof Mesh || object instanceof Line) {
    addGeometryBounds(object, target)
  }

  object.children.forEach((child) => {
    expandStepObjectBounds({ gltf, hiddenPartIds, object: child, target })
  })
}

export const getOperationStepBoundingBox = ({
  assemblyGroupIds,
  gltf,
  hiddenParts,
}: {
  assemblyGroupIds: string[]
  gltf: GLTFObject
  hiddenParts: string[]
}) => {
  if (assemblyGroupIds.length === 0) return null

  const boundingBox = new Box3()
  const hiddenPartIds = new Set(hiddenParts)

  gltf.scene.updateWorldMatrix(true, true)

  assemblyGroupIds.forEach((assemblyGroupId) => {
    const object = gltf.getObjectByUUID(assemblyGroupId)
    if (object) {
      expandStepObjectBounds({
        gltf,
        hiddenPartIds,
        object,
        target: boundingBox,
      })
    }
  })

  return boundingBox.isEmpty() ? null : boundingBox
}
